var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    { staticClass: "navbar-top", attrs: { toggleable: "md" } },
    [
      _c("p", [
        _vm._v("\n    " + _vm._s(_vm.$t("setup.navbar_header"))),
        _c(
          "strong",
          [
            _c("router-link", { attrs: { to: "/en/setup" } }, [
              _vm._v(_vm._s(_vm.$t("setup.navbar_header_link"))),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }